import gql from 'graphql-tag';

export const defaults = {
  showDashSitePlan: true,
};

const DASH_SITEPLAN = gql`
  query UserPreference {
    showDashSitePlan @client
  }
`;

export const resolvers = {
  UserPreference: {
    showDashSitePlan: (userPreference, _args, { cache }) => {
      const { showDashSitePlan } = cache.readQuery({ query: DASH_SITEPLAN });
      return showDashSitePlan;
    },
  },
  Mutation: {
    toggleDashSitePlan: (_, { id }, { cache, getCacheKey }) => {
      const { showDashSitePlan } = cache.readQuery({ query: DASH_SITEPLAN });

      const data = { showDashSitePlan: !showDashSitePlan };

      cache.writeData(data);

      return data;
    },
  },
};
